<template>
  <div>
    <div class="hero-image vimeoURLfallbackdiv" :style="{'background-image': isMobile ? `url('https://www.thethinkingtraveller.com/media/homepage/hero/campaign_crowds_img.jpg')` : `url('https://www.thethinkingtraveller.com/media/Homepage/Hero/Homepage_hero_fallback_dec23.jpg')` }" />
    <Vimeo v-if="showVideo && !isMobile" :id="891517971" hash="78e0bca88f" class="hero-image vimeoURLfallback" :image="'https://www.thethinkingtraveller.com/media/Homepage/Hero/Homepage_hero_fallback_dec23.jpg'" />
    <div class="hero-image overlay" />

    <div class="homepage__hero">
      <div class="homepage__hero--wrapper text-center">
        <div>
          <div v-if="isDesktop" class="homepage__hero--subtitle">
            <div>The soulful villa you always wanted with all details and services arranged, for all your loved ones to gather. <br> Book your 2024 Mediterranean escape now.</div>
          </div>
          <h1 class="homepage__hero--title" v-html="formatHeader(heroTitle)" />
          <div v-if="!isDesktop" class="homepage__hero--subtitle">
            The soulful villa you always wanted with all details and services arranged, for all your loved ones to gather. <br> Book your 2024 Mediterranean escape now.
          </div>
          <app-link id="16" type="page" class="btn-secondary-light-sm" :disabled="!showVideo">
            {{ cta }}
          </app-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import responsive from '../../mixins/responsive';
import Vimeo from '../../components/Vimeo.vue';
import { formatHeader } from '../../utils/formatText';

export default {
  components: {
    Vimeo,
  },
  mixins: [responsive],
  data() {
    return {
      formatHeader,
      heroTitle: 'The perks of being early',
      // heroTitle: '<span class="lowercase" style="font-style: italic;">the</span> PERKS <span class="lowercase" style="font-style: italic;"> of</span> BEING EARLY',
      heroSubtitle: 'The soulful villa you always wanted with all details and services arranged, for all your loved ones to gather. Book your 2024 Mediterranean escape now.',
      cta: 'Find your dream villa',
    };
  },
  computed: {
    showVideo() {
      return this.$store.getters['common/getApiDataLoaded'];
    },
  },
  created() {
    // @TODO 2023-10-10 Add back in when marketing would like to reintroduce alternative/randomized cases for hero h1s
    // this.getHeroText();
  },
  methods: {
    // getHeroText() {
    //   const query = this.$route.query?.hpt;
    //   switch (query) {
    //     case '2':
    //       this.heroTitle = "<div style='font-size: 77px; line-height: 1.3;'><span class='capitalcase' style='font-style: italic;'>For</span> those who don't<br>follow <span class='lowercase' style='font-style: italic;'>the</span> crowds</div>";
    //       this.heroSubtitle = ['Cosmopolitan towns to the rhythm of local life.', 'Special villas, unique experiences, a private island.', 'Discover a different Mediterranean.'];
    //       this.cta = 'Find your dream villa';
    //       break;
    //     case '3':
    //       this.heroTitle = "Being late <span class='lowercase' style='font-style: italic;'>is</span> perfect timing";
    //       this.heroSubtitle = ['Warm waters and temperate nights.', 'Iconic sights without the crowds.', 'The late-summer spirit of the Mediterranean awaits…'];
    //       this.cta = 'Late-summer villas';
    //       break;
    //     default:
    //       this.heroTitle = "<span class='capitalcase' style='font-style: italic;'>The</span> sweetness <span class='lowercase' style='font-style: italic;'>of</span> summer";
    //       this.heroSubtitle = ['Discover epic settings, irresistible pools, heavenly gardens.', 'Sea views that stop time.', ' All of our villas have something special.', 'And can still be yours.'];
    //       this.cta = 'Find your dream villa';
    //       break;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/settings/config.scss';
$hero-height: 465px;
// Please do not add z-index layering in this file as the full screen date picker is wrapped in these sections on the home page

.three-lines {
  display: inline;
}
.hero-image {
  background-size: cover;
  background-position: center;
}

.hero-overlay {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 49%, rgba(0, 0, 0, 0));
}

.hero-image {
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  @media (max-width: 480px) {
    min-height: 568px;
  }
  &.overlay {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.homepage{
  position: absolute;
  top: 0;
  left: 0;
  &__hero {
  position: relative;
  &--wrapper {
    padding: 2em 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    max-width: 970px;
    margin: 0 auto;
    padding: 4em 0;
    height: calc(100vh - 111.5px);

    @media (max-width: 900px) {
      // compensating for height of the topbar
      height: calc(100vh - 60px); // Ensure hero search is above bottom nav on mobile
      // margin-bottom: 10vh; // push rest of page content down
    }
    @media (max-width: 574px) {
      // compensating for height of the topbar
      min-height: calc(568px - 49.5px);
    }
  }

  &--signpost {
    position: absolute;
    bottom: 60px;
    left: 0;
    background-color: $black;
    color: $stoneWhite;
    font-size: 21px;
    padding: 15px 21px 15px 75px;
    & span {
      margin-left: 9px;
    }
    @media (max-width: 820px) {
      background: transparent;
      left: 0;
      right: 0;
      padding: 0;
      bottom: -10px;
      font-size: 16px;
    }
  }

  &--title {
    position: relative;
    margin: 0 auto;
    padding: 0 1em;
    color: $stoneWhite;
    font-size: calc(7.5vh + 1rem);
    text-align: center;
    line-height: 1.2;
    margin-bottom: 32px;
    font-style: italic;
    @media screen and (max-width: 900px) {
      font-size: calc(4.5vh + 1.5rem);
    }
    @media screen and (max-width: 414px) {
      font-size: calc(3.7vh + 1.3rem);
    }
  }
  &--subtitle {
    color: $stoneWhite;
    margin-bottom: 2em;
    font-size: calc(1vh + 0.6rem);
    @media screen and (max-width: 900px) {
      font-size: calc(1vh + 0.5rem);
      }
    @media screen and (max-width: 414px) {
      font-size: calc(0.7vh + 0.5rem);
      }
    }
  }
}

.show-mobile-tablet {
  @media (min-width: 1025px) {
    display: none;
  }
}

.show-desktop {
  @media (max-width: 1025px) {
    display: none;
  }
}

</style>
